<script>
    import SvelteTable from "../../../Components/Common/SvelteTable.svelte";

    import {
        getActivityLogsActionType,
        getDisplayUserName,
        getFormatDateAndTime,
        getFormatDateAndTimeWithSeconds,
        getText,
        viewLog,
    } from "../../../Utils/utilFunctions.svelte";

    import { isMobile } from "../../../stores";

    import ChangeLogsFormatted from "./ChangeLogsFormatted.svelte";

    import { LogTypes } from "../../../Utils/utilEnums.svelte";

    import { CardLayout } from "../../../Components/Common/index.svelte";
    import { eyeIcon } from "../../../Utils/utilConstants.svelte";

    export let activityLogsData = [];
    export let totalActivityLogs = 0;
    export let extended = false;
    export let showHideExtendedLogs;

    const columns = [
        {
            key: "date",
            title: "Date",
            headerClass: "text-left pl-3 cursor-default rounded-tl-xl w-[10%]",
            class: "px-3 text-left cursor-pointer",
            value: (v) => getFormatDateAndTimeWithSeconds(v.createdDate),
        },
        {
            key: "user",
            title: "User",
            headerClass: "text-left pl-3 cursor-default w-[10%]",
            class: "px-3 text-left cursor-pointer",
            value: (v) => getDisplayUserName(v),
        },
        {
            key: "controller",
            title: "Controller",
            headerClass: "text-left pl-3 cursor-default w-[10%]",
            class: "px-3 text-left cursor-pointer",
            value: (v) => getText(v.controller),
        },
        {
            key: "actionType",
            title: "Action Type",
            headerClass: "text-left pl-3 cursor-default w-[10%]",
            class: "px-3 text-left cursor-pointer",
            value: (v) => getActivityLogsActionType(v.actionType),
        },
        {
            key: "entityName",
            title: "Action",
            headerClass: "text-left pl-3 cursor-default w-[10%]",
            class: "px-3 text-left cursor-pointer",
            value: (v) => getText(v.entityName, "-"),
        },
        {
            key: "entityId",
            title: "ID",
            headerClass: "text-left pl-3 cursor-default w-[10%]",
            class: "px-3 text-left cursor-default",
            value: (v) => getText(v.entityId, "-"),
        },
        {
            key: "source",
            title: "Source",
            headerClass: "text-left pl-3 cursor-default w-[10%]",
            class: "px-3 text-left cursor-pointer",
            value: (v) => getText(v.source),
        },
        {
            key: "changes",
            title: "Changes",
            headerClass:
                "text-left pl-3 min-w-[420px] cursor-default rounded-tr-xl",
            class: "px-3 text-left cursor-pointer",
            renderComponent: {
                component: ChangeLogsFormatted,
                props: {
                    fromTable: true,
                },
            },
        },
    ];

    const handleClickCell = (
        { target: { className, classList } },
        rowData,
        key,
    ) => {
        viewLog(LogTypes.Activity, rowData.id);
    };

    // HELPER FUNCTIONS
</script>

<CardLayout 
    title={`Activity Logs (${totalActivityLogs})`}
    btnOptions={
        [
            {
                iconName: "eyeIcon",
                iFont: eyeIcon,
                btnText: `${extended ? "Hide" : "Show"} extended logs`,
                iconFunction: showHideExtendedLogs,
            }
        ]
    }
>
    {#if activityLogsData.length}
        <div
            class={$isMobile
                ? "overflow-x-auto overflow-y-visible"
                : "overflow-auto"}
        >
            <SvelteTable
                {columns}
                rows={activityLogsData}
                clickCellFunc={({ detail: { event, row, key } }) => {
                    handleClickCell(event, row, key);
                }}
                customRow="align-middle"
            />
        </div>
    {:else}
        <div class="grid flex-1 h-full card bg-white rounded-box">
            <div class="flex flex-col flex-1 px-2 py-4 w-full lg:flex-row">
                <p>No activity logs</p>
            </div>
        </div>
    {/if}
</CardLayout>

<style>
    .transition {
        transition: 0.5s linear;
    }
</style>
